var r,n;function _(){return n?r:(n=1,r=function(r){return!(!r||!r.__CANCEL__)})}export{_ as __require};
